import React, { SVGProps } from "react";
export const StepFourColoredIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="119" height="118" viewBox="0 0 119 118" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_35_1084)">
                <path
                    d="M91 14H28C21.3726 14 16 19.3726 16 26V88C16 94.6274 21.3726 100 28 100H91C97.6274 100 103 94.6274 103 88V26C103 19.3726 97.6274 14 91 14Z"
                    fill="url(#paint0_linear_35_1084)"
                />
                <path
                    d="M91 14.5H28C21.6487 14.5 16.5 19.6487 16.5 26V88C16.5 94.3513 21.6487 99.5 28 99.5H91C97.3513 99.5 102.5 94.3513 102.5 88V26C102.5 19.6487 97.3513 14.5 91 14.5Z"
                    stroke="white"
                    strokeOpacity="0.01"
                />
            </g>
            <path
                d="M59.668 65.544H66.604V71.188H59.668V82H53.276V71.188H31.108V65.204L51.576 33.856H59.668V65.544ZM53.276 41.404H53.14L37.908 65.544H53.276V41.404Z"
                fill="#0C2145"
            />
            <path
                d="M67.6161 88.8688L53.7241 74.9778C52.8891 74.1428 51.3751 71.1568 53.7241 68.9328C54.5467 68.1719 55.626 67.7492 56.7466 67.7492C57.8671 67.7492 58.9465 68.1719 59.7691 68.9328L69.1271 78.2908L89.1711 58.2468C90.0061 57.4118 93.1331 56.2618 95.2161 58.2468C97.2991 60.2318 96.0511 63.4568 95.2161 64.2918L70.6381 88.8688C70.2373 89.2695 69.6938 89.4946 69.1271 89.4946C68.5604 89.4946 68.0168 89.2695 67.6161 88.8688Z"
                fill="#B39CB8"
                stroke="white"
            />
            <path
                d="M81.5985 75.175L83.5982 73.1753C83.7358 73.0376 83.8132 72.8509 83.8132 72.6562C83.8132 72.4616 83.7358 72.2749 83.5982 72.1372C83.4605 71.9996 83.2738 71.9223 83.0792 71.9223C82.8845 71.9223 82.6978 71.9996 82.5601 72.1372L80.5604 74.1369C80.4228 74.2746 80.3455 74.4613 80.3455 74.6559C80.3455 74.8506 80.4228 75.0373 80.5604 75.175C80.6981 75.3126 80.8848 75.3899 81.0795 75.3899C81.2741 75.3899 81.4608 75.3126 81.5985 75.175V75.175Z"
                fill="white"
            />
            <path
                d="M72.0754 84.6981L78.981 77.7925C79.1186 77.6548 79.196 77.4681 79.196 77.2734C79.196 77.0788 79.1186 76.8921 78.981 76.7544C78.8433 76.6168 78.6566 76.5394 78.462 76.5394C78.2673 76.5394 78.0806 76.6168 77.943 76.7544L71.0373 83.66C70.8997 83.7977 70.8224 83.9844 70.8224 84.179C70.8224 84.3737 70.8997 84.5604 71.0373 84.6981C71.175 84.8357 71.3617 84.913 71.5564 84.913C71.751 84.913 71.9377 84.8357 72.0754 84.6981V84.6981Z"
                fill="white"
            />
            <defs>
                <filter
                    id="filter0_d_35_1084"
                    x="0"
                    y="0"
                    width="119"
                    height="118"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="8" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.239216 0 0 0 0 0.121569 0 0 0 0 0.262745 0 0 0 0.2 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_35_1084" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_35_1084" result="shape" />
                </filter>
                <linearGradient
                    id="paint0_linear_35_1084"
                    x1="69.331"
                    y1="19.59"
                    x2="10.814"
                    y2="133.577"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#B993C2" />
                    <stop offset="1" stopColor="#5D4A61" />
                </linearGradient>
            </defs>
        </svg>
    );
};
